import React, { useEffect, useState } from 'react';
import { RemoteComponent } from '@components/RemoteComponent';
import { Empty } from '@whalecloud/fdx';

const Remote = ({ element }) => {
  const { componentSettings, className, settings } = element.data;
  const { width, visible } = settings;
  const {
    url = '',
    parameter = "",
  } = componentSettings;

  const [parameters, setParameters] = useState({ formValues: {}, callBack: () => { } })

  useEffect(() => {
    try {
      setParameters(parameter ? { ...JSON.parse(parameter), formValues: {}, callBack: () => { } } : {})
    } catch (error) {
      setParameters({ formValues: {}, callBack: () => { } })
      console.log(error)
    }
  }, [parameter])

  return (
    <div className={className} style={{ width: width.value, display: visible === 'hidden' ? "none" : "block" }} >
      {
        url ? (<RemoteComponent url={url} {...parameters} />) : (
          <Empty description="This component requires a URL to render." />
        )
      }
    </div>
  );
};

export default Remote;
